<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { DropdownMenuSubTriggerProps } from 'reka-ui';
  import { DropdownMenuSubTrigger, useForwardProps } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<
    DropdownMenuSubTriggerProps & {
      class?: HTMLAttributes['class'];
      inset?: boolean;
      icon?: string;
      hideChevron?: boolean;
    }
  >();

  const delegatedProps = reactiveOmit(props, 'class', 'inset');
  const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <DropdownMenuSubTrigger
    data-slot="dropdown-menu-sub-trigger"
    v-bind="forwardedProps"
    :class="
      cn(
        'focus:bg-accent text-xs focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground flex cursor-default items-center rounded-sm p-2 outline-hidden select-none data-[inset]:pl-8 gap-2',
        props.class,
        icon && 'flex items-center w-full dropdown-menu-item-w-icon [&>i]:w-4',
      )
    "
  >
    <i v-if="icon" :class="cn('fa text-2xs w-4 text-center', icon)" />
    <slot />
    <i v-if="!hideChevron" class="far fa-chevron-right ml-auto my-auto text-2xs w-4 text-right" />
  </DropdownMenuSubTrigger>
</template>
